import { GameTypes } from "kadow-jetpack-model";
import { GameThumbnailDTO } from "../../model/GameDTO";
import { DEFAULT_EVENTS } from "../constants";
import { buildGameThumbnailDTO } from "./buildGameThumbnailDTO";

export function buildGamesListForOnboarding(): GameThumbnailDTO[] {
  if (!DEFAULT_EVENTS.length || !DEFAULT_EVENTS[0]?.skins?.length) {
    return [];
  }
  const res: GameThumbnailDTO[] = [];
  DEFAULT_EVENTS[0].skins?.forEach((s) => {
    if (s.game === GameTypes.KadowCrush || s.game == GameTypes.Prognosis) {
      return;
    }
    buildGameThumbnailDTO(res, DEFAULT_EVENTS, "default", s.game);
  });
  return res;
}
